$(function() {
    $('#register-get-client-data').click(function() {
        const identifier = $(this).parents('form').find('[name="organization_number"]').val();

        if (!identifier) {
            return false;
        }
        $.ajax({
            url: '/user/users/get-address',
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            data: JSON.stringify({
                'identifier': identifier,
                '_csrfToken': $('meta[name="csrfToken"]').attr('content'),
            }),
        }).done(function(response) {
            if (response.meta.success) {
                $('[name="organization_name"]').val(response.data[0].fullName);
                $('[name="firstname"]').val(response.data[0].firstName);
                $('[name="surname"]').val(response.data[0].lastName);
            }
        });
        return false;
    });
});